import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import itemService from '../services/item.service'
import printService from '../services/print.service'
import alertService from '../services/alert.service'
import palletApi, { PalletCreateRequest } from '../apis/pallet.api'
import itemApi, { ItemData } from '../apis/item.api'
import { ItemType } from '../apis/ItemType.api'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import Checkbox from '../components/Checkbox'

interface Props {
  onItemSelect: (item: ItemData | null) => void
  onCreate: () => void
}

interface State {
  item: string
  itemId: number | null
  items: ItemData[]
  print: boolean
}

export default class BarePalletCreateForm extends Component<Props, State> {
  initialState: State = {
    item: '',
    itemId: null,
    items: [],
    print: true
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleItemSearch = this.handleItemSearch.bind(this)
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleItemBlur = this.handleItemBlur.bind(this)
    this.handleCheckChange = this.handleCheckChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  get itemOptions () {
    return itemService.searchOptions(this.state.items)
  }

  handleItemSearch (name: string, term: string) {
    const types: ItemType[] = ['production']
    itemApi.searchByCode(term, types, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'item') {
      this.setState({ itemId: null, item: value })
      this.props.onItemSelect(null)
    }
  }

  handleItemSelect (name: string, option: SearchPickerOption) {
    const { value } = option
    const itemId = option.id as number
    const item = itemService.find(this.state.items, itemId)
    if (!item) return
    this.props.onItemSelect(item)
    this.setState({ items: [], item: value, itemId })
  }

  handleItemBlur (name: string) {
    this.setState({ items: [] })
  }

  handleCheckChange (name: string) {
    if (name === 'print') {
      this.setState(state => {
        return { print: !state.print }
      })
    }
  }

  resetState () {
    this.setState(this.initialState)
  }

  printPallet (id: number, callback: () => void) {
    const { print } = this.state
    if (!print) return callback()
    palletApi.print(id, markups => {
      if (!markups) return
      printService.printMarkups(markups)
      callback()
    })
  }

  handleCreateClick () {
    const payload: PalletCreateRequest = {}
    const { itemId } = this.state
    if (itemId) payload.item = itemId
    palletApi.create(payload, pallet => {
      if (!pallet) return
      alertService.success('Successfully created bare pallet')
      this.printPallet(pallet.id, () => {
        this.resetState()
        this.props.onCreate()
      })
    })
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Create Bare Pallet")}
          doc="pallets-create-bare-pallet" />
        <Row column={3}>
          <SearchPicker
            name="item"
            value={this.state.item}
            options={this.itemOptions}
            label={i18n("Item")}
            onSearch={this.handleItemSearch}
            onChange={this.handleInputChange}
            onSelect={this.handleItemSelect}
            onBlur={this.handleItemBlur} />
        </Row>
        <Row column={3}>
          <Checkbox
            name="print"
            label="Print pallet label"
            checked={this.state.print}
            align="start"
            onChange={this.handleCheckChange} />
        </Row>
        <CardButton
          proceedText={i18n("Create")}
          cancelText={i18n("Cancel")}
          onProceedClick={this.handleCreateClick} />
      </Card>
    )
  }
}
